import { NotificationInput } from "./NotificationInput";

export default NotificationInput;
